import BaseRepository from './base.repository';

class OnBoardingRepository extends BaseRepository {
  constructor() {
    super('/savanne');
  }

  getTreatmentsTypes(){
    return this.client.get('/treatments/types');
  }

  getTreatmentActive() {
    return this.client.get('/treatments/active');
  }

  getPILDetailsByCode(code) {
    return this.client.get(`/pil/code/${code}`);
  }

  getTreatmentDiseases(){
    return this.client.get('/treatments/diseases');
  }

  getTreatmentDiagnosis(diseaseMainUnique){
    return this.client.get('/treatments/diagnosis', { diseaseMainUnique });
  }

  createTreatmentOnboarding(payload) {
    return this.client.post('/treatments/onboarding', payload);
  }

  createTreatmentOnboarded(payload) {
    return this.client.post('/treatments/onboarded', payload);
  }

}

export default new OnBoardingRepository();
